import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FullSmartFormCategory, SmartFormLogic, SmartFormLogicAction } from '../../../../../../swaggerServices';
import { environment } from '../../../../../environments/environment';
import { ISubGroupQuestion } from '../../../tax-return-builder/tax-return-builder';

@Component({
    selector: 'smartFormLogic-card',
    templateUrl: './smartFormLogic-card.component.html',
    styleUrls: ['./smartFormLogic-card.component.scss'],
    standalone: false
})
export class SmartFormLogicCard {
  @Input() rootCondition: SmartFormLogic;
  @Input() questions: ISubGroupQuestion[];
  @Input() smartFormCategories: FullSmartFormCategory[];
  @Input() thisCategoryId: number;
  @Input() thisSubCategoryId: number;
  @Input() thisQuestionId: number;
  @Output() onClickEdit = new EventEmitter();

  ready = false;
  showActions = [];
  mandatoryActions = [];
  questionShowActions = [];
  questionMandatoryActions = [];
  subCategoryShowActions = [];
  subCategoryMandatoryActions = [];
  categoryShowActions = [];
  categoryMandatoryActions = [];
  editable = false;
  showContainsCategory = false;
  showContainsSubCategory = false;
  showContainsQuestion = false;

  mandatoryContainsCategory = false;
  mandatoryContainsSubCategory = false;
  mandatoryContainsQuestion = false;
  isProductionMode: boolean;

  constructor() {
    this.isProductionMode = environment.production;
  }

  ngOnChanges() {
    this.showActions = this.getLogicActionsByTypeAndEntity(this.rootCondition, "show");
    this.mandatoryActions = this.getLogicActionsByTypeAndEntity(this.rootCondition, "mandatory");

    this.categoryShowActions = this.getLogicActionsByTypeAndEntity(this.rootCondition, "show", 'smartFormCategory');
    this.showContainsCategory = this.categoryShowActions.some(val => val.entityId == this.thisCategoryId)
    this.categoryMandatoryActions = this.getLogicActionsByTypeAndEntity(this.rootCondition, "mandatory", 'smartFormCategory');
    this.mandatoryContainsCategory = this.categoryMandatoryActions.some(val => val.entityId == this.thisCategoryId)

    this.subCategoryShowActions = this.getLogicActionsByTypeAndEntity(this.rootCondition, "show", 'smartFormSubCategory');
    this.showContainsSubCategory = this.subCategoryShowActions.some(val => val.entityId == this.thisSubCategoryId)
    this.subCategoryMandatoryActions = this.getLogicActionsByTypeAndEntity(this.rootCondition, "mandatory", 'smartFormSubCategory');
    this.mandatoryContainsSubCategory = this.subCategoryMandatoryActions.some(val => val.entityId == this.thisSubCategoryId)

    this.questionShowActions = this.getLogicActionsByTypeAndEntity(this.rootCondition, "show", 'question');
    this.showContainsQuestion = this.questionShowActions.some(val => val.entityId == this.thisQuestionId)
    this.questionMandatoryActions = this.getLogicActionsByTypeAndEntity(this.rootCondition, "mandatory", 'question');
    this.mandatoryContainsQuestion = this.questionMandatoryActions.some(val => val.entityId == this.thisQuestionId)


    this.editable = this.onClickEdit.observers.length > 0;
    this.ready = true;
  }

  getLogicActionsByTypeAndEntity(logic: SmartFormLogic, action: "show" | "mandatory", entity: 'any' | SmartFormLogicAction.EntityEnum = 'any') {
    if (entity == 'any') {
      return logic.actions?.filter(val => val[action] === true);
    }
    else {
      return logic.actions?.filter(val => val.entity == entity &&  val[action] === true);
    }
  }

  triggerEdit() {
    this.onClickEdit.emit(this.rootCondition)
  }

  getQuestionById(id) {
    return this.questions.find(val => val.id == id)?.question;
  }
}
